import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'
import request from './request'
import axios from 'axios'

export default class ApplicationApi {
  async getHeaders(type) {
    const token = await Vue.prototype.$auth.getUserToken()
    const headers = {
      'Content-Type': type || 'multipart/form-data',
      'Authorization': `Bearer ${token ? token : ''}`,
      'Auth-Provider': 'SmartId',
      'OrganizationItId': sessionStorage.getItem('OrganizationItId'),
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*',
      'culture': sessionStorage.language,
      'accept-language': sessionStorage.language,
      'href': window.location.href,
    }
    if (crypto?.randomUUID)  {
      headers.correlationId = crypto.randomUUID()
    }
    const user = (await Vue.prototype.$auth.getUser())
    let my_local = localStorage.getObject(`${(user.profile.preferred_username || '').toLowerCase()}_settings`),
      GodMode = my_local && my_local.GodMode
    if (GodMode) {
      headers.GodMode = +GodMode
    }
    return headers
  }

  async getPurchaseSettings(model) {
    return await request( {environment: '/common',
      type: 'query',
      name: 'purchaseSettings',
      variables: { model },
      way: './graphql/purchasing/',
      catch_callback: error => {
        throw error
      }})
  }

  getApplicationCallback(response) {
    let applications = response.data.applications
    Vue.prototype.$store.commit('setApplications', applications)
    return response
  }

  async getApplicationCounts(text, conditions) {
    let query = await import('./graphql/applications/applicationCounts.graphql')
    return (await getApolloClient(null, null, true))
      .query({
        query: gql`${query}`,
        variables: {
          query: text,
          conditions
        }
      })
      .then(this.getApplicationCountsCallback)
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  getApplicationCountsCallback(response) {
    let applications = response.data.applicationCounts
    // Vue.prototype.$store.commit('setApplicationCounts', applications)
    return applications
  }

  async getApplicationById(id) {
    let query = await import('./graphql/applications/getApplicationById.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${query}`,
        variables: {
          id: id
        }
      })
      .then(this.getApplicationCallback)
      //.catch(error => Vue.prototype.$log_error(error.message))
  }
  async getApplicationEvents(id) {
    let query = await import('./graphql/applications/changeHistory.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${query}`,
        variables: { appId: id }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  async getApplicationChats(id) {
    let query = await import('./graphql/applications/chats.gql')
    return (await getApolloClient()).query({
      query: gql`${query}`,
      variables: { appId: id }
    })
  }
  async createApplication() {
    let createApplication = await import('./graphql/applications/createApplication.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${createApplication}`
      })
      .then(this.createApplicationCallback)
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }
  createApplicationCallback(response) {
    let application = response.data.createApplication
    Vue.prototype.$store.commit('addNewApplication', application)
    return response
  }
  async appendApplication(application) {
    let createApplication = await import('./graphql/applications/appendApplication.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${createApplication}`,
        variables: {
          applicationId: application
        }
      })
      .then(this.createApplicationCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  appendApplicationCallback(response) {
    let application = response.data.createApplication
    Vue.prototype.$store.commit('editApplicationData', application)
    return response
  }
  async sendApplication(id) {
    let sendApplication = await import('./graphql/applications/sendApplication.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${sendApplication}`,
        variables: {
          applicaitonId: id
        }
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }
  async editApplication(data, comm) {
    let editApplication = await import('./graphql/applications/editApplication.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${editApplication}`,
        variables: {applicationInput: data, comment: comm}
      })
      .then(this.editApplicationCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  editApplicationCallback(response) {
    let application = response.data.editApplication
    // Vue.prototype.$store.commit('editApplicationData', application)
    return application
  }

  async editApplicationRow(data, comment) {
    let editApplicationRow = await import('./graphql/applications/editApplicationRow.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${editApplicationRow}`,
        variables: {
          applicationRowInput: data,
          comment: comment
        }
      })
      .then(this.editApplicationRowCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  editApplicationRowCallback(response) {
    let applicationRow = response.data.editApplicationPublishedRow
    Vue.prototype.$store.commit('editApplicationRowData', applicationRow)
    return applicationRow
  }

  async changeRowsInDraft({rows, headerId}) {
    let changeRowsInDraft = await import('./graphql/applications/changeRowsInDraft.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${changeRowsInDraft}`,
        variables: {
          rows, headerId
        }
      })
      .then(this.changeRowsInDraftCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  changeRowsInDraftCallback(response) {
    // let applicationRow = response.data.changeRowsInDraft
    // Vue.prototype.$store.commit('editApplicationRowData', applicationRow)
    return response
  }

  async addRowsToDraft({rows, headerId}) {
    let addRowsToDraft = await import('./graphql/applications/addRowsToDraft.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${addRowsToDraft}`,
        variables: {
          rows, headerId
        }
      })
      .then(this.addRowsToDraftCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  addRowsToDraftCallback(response) {
    let applicationRows = response.data.addRowsToDraft
    if ( !applicationRows) {
      throw 'Error addRowsToDraft'
    }
    // Vue.prototype.$store.commit('editApplicationRowData', applicationRow)
    return applicationRows
  }

  async duplicateRow(headerId, id) {
    let duplicateRow = await import('./graphql/applications/duplicateRow.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${duplicateRow}`,
        variables: {headerId: headerId, id: id}
      })
      .then(this.duplicateRowCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  duplicateRowCallback(response) {
    let item = response.data.duplicateRow
    // Vue.prototype.$store.commit('addApplicationRow', item)
    return item
  }

  async duplicateApplication(applicationId) {
    let duplicateApplication = await import('./graphql/applications/duplicateApplication.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${duplicateApplication}`,
        variables: {applicationId: applicationId}
      })
      .then(this.duplicateApplicationCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  duplicateApplicationCallback(response) {
    let item = response.data.duplicateApplication
    Vue.prototype.$store.commit('addNewApplication', item)
    return response
  }

  async deleteRows(headerId, ids) {
    let deleteRows = await import('./graphql/applications/deleteRows.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${deleteRows}`,
        variables: {
          headerId: headerId,
          ids
        }
      }).catch(error => Vue.prototype.$log_error(error.message))
  }
  async deleteApplication(headerId) {
    let deleteApplication = await import('./graphql/applications/deleteApplication.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${deleteApplication}`,
        variables: {
          headerId: headerId,
        }
      })
      .then(this.deleteApplicationCallback)
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  deleteApplicationCallback(response) {
    // let item = response.data.deleteApplication
    // Vue.prototype.$store.commit('deleteApplication', item)
    return response.data.deleteApplication
  }

  async agreeApplication(applicaitonId, decision, comment) {
    let agreeApplication = await import('./graphql/applications/agreeApplication.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${agreeApplication}`,
        variables: {
          applicaitonId: +applicaitonId,
          decision: decision,
          comment: comment
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async agreeApplicationRows(applicaitonId, npps, decision, comment) {
    let agreeApplicationRows = await import('./graphql/applications/agreeApplicationRows.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${agreeApplicationRows}`,
        variables: {
          applicaitonId: applicaitonId,
          npps: npps,
          decision: decision,
          comment: comment
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async saveEvent(eventType) {
    return await request({
      environment: '/common',
      type: 'mutation',
      name: 'saveEvent',
      variables: { eventType },
      way: './graphql/common/'
    })
  }
  async getEvents(filter) {
    return await request( {
      environment: '/common',
      type: 'query',
      name: 'getEvents',
      variables: { filter },
      way: './graphql/common/'
    })

    /*let query = await import('./graphql/common/getEvents.gql')
    return(await getApolloClient())
      .query({
        query: gql`${query}`,
        variables: {
          filter: filter
        }
      })
      .then(this.addAcceptorsCallback)
      .catch(error => Vue.prototype.$log_error(error.message))*/
  }
  async getStatuses() {
    let getStatuses = await import('./graphql/applications/getStatuses.graphql')
    return (await getApolloClient())
      .query({ query: gql`${getStatuses}` })
      .then(this.getStatusesCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }
  getStatusesCallback(response) {
    let statuses = response.data.statuses
    Vue.prototype.$store.commit('setStatuses', statuses)
    return statuses
  }

  async getAcceptorsByIds(ids) {
    let query = await import('./graphql/applications/getAcceptorsByIds.graphql')
    return (await getApolloClient())
      .query({
        query: gql`${query}`,
        variables: {
          applicationIds: ids
        }
      })
      .then(this.addAcceptorsCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  addAcceptorsCallback(response) {
    let acceptors = response.data.getApplicationsAcceptors
    // acceptors?.forEach(el => Vue.prototype.$store.commit('addAcceptorsData', el))
    return acceptors
  }

  async getApplicationAcceptors(id) {
    let query = await import('./graphql/applications/getApplicationAcceptors.gql')
    return (await getApolloClient())
      .query({
        query: gql`${query}`,
        variables: {
          applicationId: id
        }
      })
      .then(res => res.data.getApplicationAcceptors)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async purchasePlans() {
    let query = await import('./graphql/applications/purchasePlans.graphql')
    return (await getApolloClient())
      .query({ query: gql`${query}`, })
      .then(res => res.data.purchasePlans)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async purchasingPlan(filters, unionType) {
    let query = await import('./graphql/applications/purchasingPlan.graphql')
    return (await getApolloClient(null, null, true))
      .query({
        query: gql`${query}`,
        variables: { filters, unionType }
      })
      .then(res => res.data.purchasingPlan)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async createOrdersUsers() {
    let query = await import('./graphql/applications/createOrdersUsers.graphql')
    return (await getApolloClient())
      .query({ query: gql`${query}`, })
      .then(this.createOrdersUsersCallback)
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  createOrdersUsersCallback(response) {
    let users = response.data.applicationsCreators
    Vue.prototype.$store.commit('setCreateOrdersUsers', users)
    return users
  }


  /** chat witch participats */
  async getTenderQuestions(tenderId) {
    return await request( {environment: '/tenders', type: 'query', name: 'getTenderQuestions', variables: { tenderId }, way: './graphql/applications/'})
  }
  async addOrChangeQuestion(tenderId, questionId, model, files) {
    const getGqlString = (doc) => {
      return doc.loc && doc.loc.source.body
    }
    model.userIds =  model.userIds?.filter((v, i, a) => a.indexOf(v) === i) || []

    if (!files?.length) {
      return await request( {environment: '/tenders', type: 'mutation', name: 'addOrChangeQuestion', variables: { tenderId, questionId, model,files: null }, way: './graphql/applications/'})
    }

    let sendQuestion = await import('./graphql/applications/addOrChangeQuestion.gql')
    let formdata = new FormData()

    const query = {
      query: getGqlString(gql`${sendQuestion}`),
      variables: {
        tenderId: tenderId,
        questionId: questionId,
        model: model,
      },
      operationName: null
    }
    let mapdata = {}

    formdata.append('operations', JSON.stringify(query))
    mapdata[0] = ['variables.files']
    files.forEach((file, index) => {
      let fileItem = file
      if (Array.isArray(file)) {
        fileItem = file[0]
      }
      formdata.append(index, fileItem, fileItem.name)
    })
    formdata.append('map', JSON.stringify(mapdata))

    const uri = window.config.GrapgQlUrl + '/tenders'
    return await axios.post(uri, formdata,
      {
        headers: await this.getHeaders(),
        onUploadProgress: this.listener
      }).then((res) => {
      return res.data.data.addOrChangeQuestion
    })
      .catch(function() {
        return null
      })
  }
  async deleteQuestion(tenderId, questionId) {
    return await request( {environment: '/tenders', type: 'mutation', name: 'deleteQuestion', variables: { tenderId, questionId }, way: './graphql/applications/'})
  }
  /** chat witch participats */

  /** inner chat */
  async getInnerChatMessage(model) {
    return await request( {environment: '/notifications',
      type: 'query',
      name: 'getInnerChatMessage',
      variables: { model },
      way: './graphql/innderChat/',
      // чату по сутності ще немає — очікувана ситуація, не помилка для Sentry
      ignoredErrorCodes: ['ChatDoesNotExist'],
      catch_callback: error => {
        throw error
      }})
  }
  /** inner chat */
}
